<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
      checkValidation: checkValidation$ | async,
    };
    as data
  ) {
    @if (!isLoading()) {
      @if (
        ((projektTimeSection && projektPartSection) ||
          (isChangeRequest() && projektPartSection)) &&
        startDate &&
        endDate &&
        parter
      ) {
        <div class="row" *ngTemplateOutlet="infoOrMissingAnswerTemplate"></div>
      }
      @if (startDate && endDate && parter) {
        <div class="top-row">
          <div class="dateboxes" [class.shared-view]="isSharedView()">
            <div class="datebox">
              <span class="date-title">{{
                t('question_budget_date_start')
              }}</span>
              <div>
                {{ startDate | date: 'yyyy-MM-dd' }}
              </div>
            </div>
            <div class="datebox">
              <span class="date-title">{{
                t('question_budget_date_end')
              }}</span>
              <div>
                {{ endDate | date: 'yyyy-MM-dd' }}
              </div>
            </div>
            @if (newProjektEndDate) {
              <div class="datebox">
                <span class="date-title">{{ t('begaran_new_end_date') }}</span>
                <div>
                  {{ newProjektEndDate | date: 'yyyy-MM-dd' }}
                </div>
              </div>
            }
          </div>
          @if (canImportBudget() && data.readOnly === ReadonlyState.Editable) {
            <div class="mt-5 align-self-start">
              <button
                vinnova-button-secondary
                size="small"
                type="button"
                (click)="openBudgetImport()"
              >
                <lib-icon name="upload" size="x-small"></lib-icon>
                Importera budget från Excel
              </button>
            </div>
          }
          @if (isSharedView() && data.readOnly === ReadonlyState.Editable) {
            <div class="separator"></div>
            <div class="shared-view-buttons">
              <button
                vinnova-button-secondary
                size="small"
                (click)="openMasshanteraStodgrund()"
              >
                Masshantera stödgrund
              </button>
              <span class="d-flex gap-1">
                <button
                  vinnova-button-secondary
                  size="small"
                  (click)="avrundaStodniva()"
                >
                  Avrunda stödnivå
                </button>
                <lib-icon
                  name="help-circle"
                  class="description-icon"
                  libTooltip="Beräknad stödnivå avrundas uppåt och sätts som maximal stödnivå.
              Observera att detta inte är den legala maximala stödnivån."
                  triggers="click"
                  tabindex="0"
                />
              </span>
            </div>
          }
        </div>
      }

      @if (
        (((projektTimeSection && projektPartSection) || isChangeRequest()) &&
          startDate &&
          endDate &&
          parter) ||
        formBuilder()
      ) {
        <div class="intro-text">
          <strong
            [innerHTML]="
              question().translations?.list['headLine']
                | translate: data.activeLang : question().structure.headLine
            "
          ></strong>
          <div
            [innerHTML]="
              question().translations?.list['description']
                | translate: data.activeLang : question().structure.description
            "
          ></div>
        </div>
      }

      @if (
        (projektTimeSection && projektPartSection) ||
        (isChangeRequest() && projektPartSection) ||
        isSharedView()
      ) {
        @if (startDate && endDate && parter) {
          <div
            class="coordinator-container"
            [class.shared-view]="isSharedView()"
          >
            <p class="heading-size-4">
              {{ t('question_budget_coordinator_header') }}
            </p>
            <ng-container
              *ngTemplateOutlet="
                projektpartTablesTemplate;
                context: {
                  worksite: parter.koordinator.worksite,
                  coordinator: true,
                  newprojektpart: newProjektparter.has(
                    parter.koordinator.worksite.id
                  ),
                }
              "
            ></ng-container>
          </div>

          <div class="projektparter-container">
            <div class="d-flex justify-content-between projektparter-header">
              <p class="heading-size-4">
                <strong>{{ t('question_budget_participants_header') }}</strong>
              </p>

              @if (parter.projektparter.length > 0) {
                <div>
                  <div class="d-flex justify-content-end d-md-flex">
                    <button
                      vinnova-button-text
                      (click)="toggleCollapseAll(true, false)"
                    >
                      <lib-icon name="maximize-2" size="small"></lib-icon>
                      {{ t('question_budget_expand_all') }}
                    </button>
                    <button
                      vinnova-button-text
                      (click)="toggleCollapseAll(false, false)"
                    >
                      <lib-icon name="minimize-2" size="small"></lib-icon>
                      {{ t('question_budget_minimize_all') }}
                    </button>
                  </div>
                </div>
              }
            </div>
            @if (parter.projektparter.length === 0 && !isSharedView()) {
              <div>
                {{
                  t(
                    'question_budget_validation_missing_participant_participant'
                  )
                }}

                <button
                  vinnova-button-link
                  type="button"
                  (click)="goToSection(projektPartSection.id)"
                >
                  {{
                    getSectionNumber(projektPartSection.id) +
                      (projektPartSection.translations?.list['title']
                        | translate: data.activeLang : projektPartSection.title)
                  }}
                </button>
              </div>
            }

            @for (
              projektpart of parter.projektparter;
              track projektpart.worksite.id
            ) {
              <div class="projektpart">
                <ng-container
                  *ngTemplateOutlet="
                    projektpartTablesTemplate;
                    context: {
                      worksite: projektpart.worksite,
                      coordinator: false,
                      newprojektpart: newProjektparter.has(
                        projektpart.worksite.id
                      ),
                    }
                  "
                ></ng-container>
              </div>
            }
          </div>

          @if (inaktivaProjektparter.length > 0) {
            <div class="projektparter-container">
              <div class="d-flex justify-content-between projektparter-header">
                <p class="heading-size-4">
                  <strong>{{
                    t('question_budget_inactive_participants')
                  }}</strong>
                </p>

                <div class="d-flex justify-content-end d-md-flex">
                  <button
                    vinnova-button-text
                    (click)="toggleCollapseAll(true, true)"
                  >
                    <lib-icon name="maximize-2" size="small"></lib-icon>
                    {{ t('question_budget_expand_all') }}
                  </button>
                  <button
                    vinnova-button-text
                    (click)="toggleCollapseAll(false, true)"
                  >
                    <lib-icon name="minimize-2" size="small"></lib-icon>
                    {{ t('question_budget_minimize_all') }}
                  </button>
                </div>
              </div>

              @for (projektpart of inaktivaProjektparter; track $index) {
                <div class="projektpart">
                  <ng-container
                    *ngTemplateOutlet="
                      projektpartTablesTemplate;
                      context: {
                        worksite: projektpart.worksite,
                        coordinator: false,
                        inactive: true,
                        removed: removedProjektparter.has(
                          projektpart.worksite.id
                        ),
                      }
                    "
                  ></ng-container>
                </div>
              }
            </div>
          }

          <div class="total">
            <p class="heading-size-4">
              {{ t('question_budget_total_header') }}
            </p>

            <div>
              <lib-interactive-table
                [id]="question().id + '_total_k'"
                [hideExpand]="true"
                [rows]="budgetStandard() ? ROWSSTANDARD : KOSTNADSSLAG"
                [columns]="yearColumns"
                [sumRow]="true"
                [sumCol]="!budgetStandard()"
                [readonly]="true"
                [maxColsDesktop]="7"
                [readonlyData]="totalKostnader"
                [tableContentToRight]="true"
                [disableResize]="true"
                size="medium"
                [totalHeading]="t('question_budget_total_kostnader_header')"
                [tableHeading]="t('question_budget_kostnader_table_header')"
                [readOnly$]="readOnly$"
                [hideValidation]="data.readOnly === ReadonlyState.Reader"
                [browseLarge]="browseLarge()"
                [browseMedium]="browseMedium()"
                [browseSmall]="browseSmall()"
                [changes]="showChanges() ? totalKostnaderChanges : undefined"
              ></lib-interactive-table>
            </div>

            <div class="mt-2">
              <lib-interactive-table
                [id]="question().id + '_total_f'"
                [hideExpand]="true"
                [rows]="FINANSIERING"
                [columns]="yearColumns"
                [sumRow]="true"
                [sumCol]="true"
                [readonly]="true"
                [maxColsDesktop]="7"
                [readonlyData]="totalFinansiering"
                [tableContentToRight]="true"
                [disableResize]="true"
                size="medium"
                [totalHeading]="t('question_budget_total_finansiering_header')"
                [tableHeading]="t('question_budget_finansiering_table_header')"
                [readOnly$]="readOnly$"
                [hideValidation]="data.readOnly === ReadonlyState.Reader"
                [browseLarge]="browseLarge()"
                [browseMedium]="browseMedium()"
                [browseSmall]="browseSmall()"
                [changes]="showChanges() ? totalFinansieringChanges : undefined"
              ></lib-interactive-table>
              @if (
                questionForm().get('soktBidrag').errors &&
                questionForm().get('soktBidrag').errors[
                  'BudgetVinnovaTotalFinansiering'
                ]
              ) {
                <div class="invalid-feedback">
                  <span
                    ><lib-icon
                      name="alert-circle"
                      aria-hidden="true"
                      size="small"
                    ></lib-icon>
                    Det totala bidraget från Vinnova ({{
                      questionForm().value.soktBidrag | number: undefined : 'sv'
                    }}
                    kr) skiljer sig från Vinnovas totala finansiering ({{
                      effektaTotalFinansiering() | number: undefined : 'sv'
                    }}
                    kr) under fliken Finans
                  </span>
                </div>
              }
            </div>

            <ng-container
              *ngTemplateOutlet="
                beraknadStodnivaTemplate;
                context: {
                  percentage: beraknadStodniva.get('total'),
                  total: true,
                }
              "
            ></ng-container>
          </div>
          <div aria-live="polite">
            @if (
              data.readOnly !== ReadonlyState.Reader &&
              ((questionForm().invalid &&
                questionForm().touched &&
                questionForm().dirty) ||
                (readOnly$ | async)) &&
              (questionForm().errors ||
                questionForm().get('stodniva').errors ||
                questionForm().get('soktBidrag').errors ||
                questionForm().get('value').errors)
            ) {
              <div class="invalid-feedback">
                @if (
                  questionForm().get('value').errors &&
                  questionForm().get('value').errors['BudgetMinBidrag']
                ) {
                  <span
                    ><lib-icon
                      name="alert-circle"
                      aria-hidden="true"
                      size="small"
                    ></lib-icon>
                    {{ t('question_budget_validation_min_bidrag') }}
                  </span>
                }
                @if (
                  questionForm().get('stodniva').errors &&
                  questionForm().get('stodniva').errors['max']
                ) {
                  <span
                    ><lib-icon
                      name="alert-circle"
                      aria-hidden="true"
                      size="small"
                    ></lib-icon>
                    {{
                      t('question_budget_validation_max_stodniva', {
                        stodniva:
                          (questionForm().get('stodniva').errors['max'].max
                          | numberFormat),
                      })
                    }}
                  </span>
                }
                @if (
                  questionForm().get('soktBidrag').errors &&
                  questionForm().get('soktBidrag').errors['max']
                ) {
                  <span
                    ><lib-icon
                      name="alert-circle"
                      aria-hidden="true"
                      size="small"
                    ></lib-icon>
                    {{
                      t('question_budget_validation_max_sokt_bidrag', {
                        soktBidrag:
                          (questionForm().get('soktBidrag').errors['max'].max
                          | numberFormat),
                      })
                    }}
                  </span>
                }
                @if (
                  questionForm().get('soktBidrag').errors &&
                  questionForm().get('soktBidrag').errors[
                    'BudgetFinansieringNotChanged'
                  ]
                ) {
                  <span
                    ><lib-icon
                      name="alert-circle"
                      aria-hidden="true"
                      size="small"
                    ></lib-icon>
                    {{
                      t('question_budget_validation_finansiering_not_changed')
                    }}
                  </span>
                }
              </div>
            }
          </div>
        } @else {
          <ng-container
            *ngTemplateOutlet="infoOrMissingAnswerTemplate"
          ></ng-container>
        }
      } @else {
        <ng-container
          *ngTemplateOutlet="missingQuestionTemplate"
        ></ng-container>
      }

      <ng-template #infoOrMissingAnswerTemplate>
        <div class="col-lg-11">
          <p>
            @if (!parter || !(startDate && endDate)) {
              <span>{{ t('question_budget_validation_missing') }}</span>
            }
            @if (!parter) {
              <br />
            }
            @if (!parter || (parter && startDate && endDate)) {
              <span>
                {{ t('question_budget_validation_missing_participant') }}
                <button
                  vinnova-button-link
                  type="button"
                  (click)="goToSection(projektPartSection.id)"
                >
                  {{
                    getSectionNumber(projektPartSection.id) +
                      (projektPartSection.translations?.list['title']
                        | translate: data.activeLang : projektPartSection.title)
                  }}</button
                >.</span
              >
            }
            @if (!(startDate && endDate) || (parter && startDate && endDate)) {
              @if (projektTimeSection) {
                <span>
                  {{ t('question_budget_validation_missing_date') }}
                  <button
                    vinnova-button-link
                    type="button"
                    (click)="goToSection(projektTimeSection.id)"
                  >
                    {{
                      getSectionNumber(projektTimeSection.id) +
                        (projektTimeSection.translations?.list['title']
                          | translate
                            : data.activeLang
                            : projektTimeSection.title)
                    }}</button
                  >.</span
                >
              }
            }
          </p>
          @if (!(parter && startDate && endDate) && data.checkValidation) {
            <div class="invalid-feedback"></div>
          }
        </div>
      </ng-template>

      <ng-template #missingQuestionTemplate>
        <p>
          Fråga om projekttid och/eller fråga om projektparter saknas i
          formuläret
        </p>
      </ng-template>

      <ng-template
        #beraknadStodnivaTemplate
        let-worksiteId="worksiteId"
        let-percentage="percentage"
        let-total="total"
        let-maxStodniva="maxStodniva"
        let-stodgrund="stodgrund"
        let-sfsStodgrund="sfsStodgrund"
        let-bidragsMottagare="bidragsMottagare"
      >
        @if (
          bidragsMottagare &&
          isSharedView() &&
          data.readOnly === ReadonlyState.Editable
        ) {
          <div class="beraknad-stodniva-readonly">
            <div class="row beraknad-stodniva-readonly">
              <div class="col-6">
                @if (
                  {
                    moreDecimals:
                      (percentage | number: '1.1-1' : 'sv') ===
                        (maxStodniva | number: '1.1-2' : 'sv') &&
                      maxStodniva < percentage,
                  };
                  as validation
                ) {
                  <div class="beraknad-stodniva-readonly-container">
                    <lib-input-container
                      [label]="'Beräknad stödnivå'"
                      [required]="true"
                      [warningText]="
                        validation.moreDecimals
                          ? 'Fler decimaler finns i beräknad stödnivå. Prova att minska bidraget med några kronor'
                          : ''
                      "
                    >
                      <div
                        class="readonly-box d-flex justify-content-between align-items-center"
                        [class.warning]="validation.moreDecimals"
                      >
                        <span class="d-flex align-items-center">
                          <lib-dot-indicator
                            [isVisible]="
                              hasBeraknadStodnivaChanged(worksiteId) &&
                              showChanges()
                            "
                            ariaLabel="{{
                              t('question_budget_beraknad_stodniva_changes')
                            }}"
                            [tooltip]="
                              getChangeMarkTooltipHtml(
                                worksiteId,
                                'beraknadStodniva'
                              )
                            "
                            [ariaDescription]="
                              getChangeMarkTooltipDescription(
                                worksiteId,
                                'beraknadStodniva'
                              )
                            "
                          ></lib-dot-indicator>
                          {{ percentage | number: '1.1-1' : data.activeLang }}%
                        </span>
                      </div>
                    </lib-input-container>
                  </div>
                }
              </div>
              <div class="col-6">
                @if (
                  { maxStodniva: getMaxStodnivaValidation(worksiteId) };
                  as validation
                ) {
                  <lib-input-container
                    [label]="'Maximal stödnivå'"
                    [required]="true"
                    [for]="'max-stodniva'"
                    [errorText]="validation.maxStodniva"
                    [inputType]="InputType.Number"
                  >
                    <div class="d-flex align-items-center">
                      <lib-dot-indicator
                        [isVisible]="
                          hasMaxStodnivaChanged(worksiteId) && showChanges()
                        "
                        ariaLabel="{{
                          t('question_budget_max_stodniva_changes')
                        }}"
                        [tooltip]="
                          getChangeMarkTooltipHtml(worksiteId, 'maxStodniva')
                        "
                        [ariaDescription]="
                          getChangeMarkTooltipDescription(
                            worksiteId,
                            'maxStodniva'
                          )
                        "
                      ></lib-dot-indicator>
                      <input
                        vinnova-text-input
                        [id]="'max-stodniva'"
                        [required]="true"
                        [ngModel]="maxStodniva"
                        (ngModelChange)="maxStodnivaChange(worksiteId, $event)"
                        [error]="validation.maxStodniva"
                        [inputType]="InputType.Number"
                        (keydown)="onKeydownMaxStodgrund($event)"
                      />
                    </div>
                  </lib-input-container>
                }
              </div>
            </div>
            <div class="row stodgrund-row">
              <div class="col-6">
                <lib-input-container
                  [label]="'Stödgrund'"
                  [required]="true"
                  [for]="'stodgrund'"
                  [errorText]="!stodgrund ? 'Välj stödgrund' : undefined"
                >
                  <div class="d-flex align-items-center">
                    <lib-dot-indicator
                      [isVisible]="
                        hasStodgrundChanged(worksiteId) && showChanges()
                      "
                      ariaLabel="{{ t('question_budget_stodgrund_changes') }}"
                      [tooltip]="
                        getChangeMarkTooltipHtml(worksiteId, 'stodgrund')
                      "
                      [ariaDescription]="
                        getChangeMarkTooltipDescription(worksiteId, 'stodgrund')
                      "
                    ></lib-dot-indicator>
                    <lib-vinnova-dropdown
                      class="flex-grow-1"
                      style="min-width: 0"
                      [id]="'stodgrund'"
                      [items]="stodgrunderItems"
                      [required]="true"
                      [ngModel]="stodgrund"
                      (ngModelChange)="stodgrundChange(worksiteId, $event)"
                      [error]="!stodgrund"
                    >
                    </lib-vinnova-dropdown>
                  </div>
                </lib-input-container>
              </div>
              @if (sfsStodgrunderItems[stodgrund]?.length > 0) {
                <div class="col-6">
                  <lib-input-container
                    [label]="'Vinnovas förordning SFS 2015:208'"
                    [required]="true"
                    [for]="'sfs-stodgrund'"
                    [errorText]="!sfsStodgrund ? 'Välj stödgrund' : undefined"
                  >
                    <div class="d-flex align-items-center">
                      <lib-dot-indicator
                        [isVisible]="
                          hasSfsStodgrundChanged(worksiteId) && showChanges()
                        "
                        ariaLabel="{{ t('question_budget_stodgrund_changes') }}"
                        [tooltip]="
                          getChangeMarkTooltipHtml(worksiteId, 'sfsStodgrund')
                        "
                        [ariaDescription]="
                          getChangeMarkTooltipDescription(
                            worksiteId,
                            'sfsStodgrund'
                          )
                        "
                      ></lib-dot-indicator>
                      <lib-vinnova-dropdown
                        class="flex-grow-1"
                        style="min-width: 0"
                        [id]="'sfs-stodgrund'"
                        [items]="sfsStodgrunderItems[stodgrund]"
                        [required]="true"
                        [ngModel]="sfsStodgrund"
                        (ngModelChange)="sfsStodgrundChange(worksiteId, $event)"
                        [error]="!sfsStodgrund"
                      >
                      </lib-vinnova-dropdown>
                    </div>
                  </lib-input-container>
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="mt-2 beraknad-stodniva">
            <div class="d-flex w-100 justify-content-between">
              <span
                >{{
                  total
                    ? t('question_budget_aid_intensity_total')
                    : t('question_budget_aid_intensity')
                }}
                <div class="position-relative d-inline">
                  <div class="tooltip-target-area">
                    <div
                      class="tooltip-container"
                      role="tooltip"
                      [libTooltip]="
                        t('question_budget_aid_intensity_description')
                      "
                      triggers="click"
                      tabindex="0"
                    >
                      <lib-icon
                        name="help-circle"
                        class="description-icon"
                        size="x-small"
                      ></lib-icon>
                    </div>
                  </div>
                </div>
              </span>
              <div class="d-flex">
                <lib-dot-indicator
                  [isVisible]="
                    hasBeraknadStodnivaChanged(total ? 'total' : worksiteId) &&
                    showChanges()
                  "
                  [tooltip]="
                    getChangeMarkTooltipHtml(
                      total ? 'total' : worksiteId,
                      'beraknadStodniva'
                    )
                  "
                  ariaLabel="{{
                    total
                      ? t('question_budget_beraknad_stodniva_total_changes')
                      : t('question_budget_beraknad_stodniva_changes')
                  }}"
                  [ariaDescription]="
                    getChangeMarkTooltipDescription(
                      total ? 'total' : worksiteId,
                      'beraknadStodniva'
                    )
                  "
                ></lib-dot-indicator>
                <span class="percentage">
                  {{ percentage | number: '1.1-1' : data.activeLang }}%
                </span>
              </div>
            </div>
            @if (bidragsMottagare && (isSharedView() || isChangeRequest())) {
              <div class="mt-4 d-flex w-100 justify-content-between">
                <span
                  >{{ t('question_budget_max_stodniva') }}
                  <div class="position-relative d-inline">
                    <div class="tooltip-target-area">
                      <div
                        class="tooltip-container"
                        role="tooltip"
                        [libTooltip]="t('question_budget_max_stodniva_tooltip')"
                        triggers="click"
                        tabindex="0"
                      >
                        <lib-icon
                          name="help-circle"
                          class="description-icon"
                          size="x-small"
                        ></lib-icon>
                      </div>
                    </div>
                  </div>
                </span>
                <div class="d-flex">
                  <lib-dot-indicator
                    [isVisible]="hasMaxStodnivaChanged(worksiteId)"
                    ariaLabel="{{ t('question_budget_max_stodniva_changes') }}"
                    [tooltip]="
                      getChangeMarkTooltipHtml(worksiteId, 'maxStodniva')
                    "
                    [ariaDescription]="
                      getChangeMarkTooltipDescription(worksiteId, 'maxStodniva')
                    "
                  ></lib-dot-indicator>
                  <span class="percentage">{{ maxStodniva }}%</span>
                </div>
              </div>
            }
          </div>
          @if (bidragsMottagare && (isSharedView() || isChangeRequest())) {
            <div class="mt-2 beraknad-stodniva">
              <div class="d-flex w-100 justify-content-between">
                <span>{{ t('question_budget_stodgrund') }} </span>
                @if (stodgrund) {
                  <div class="ms-2">
                    <div class="d-flex justify-content-end">
                      <lib-dot-indicator
                        [isVisible]="hasStodgrundChanged(worksiteId)"
                        ariaLabel="{{ t('question_budget_stodgrund_changes') }}"
                        [tooltip]="
                          getChangeMarkTooltipHtml(worksiteId, 'stodgrund')
                        "
                        [ariaDescription]="
                          getChangeMarkTooltipDescription(
                            worksiteId,
                            'stodgrund'
                          )
                        "
                      ></lib-dot-indicator>
                      <span class="d-flex justify-content-end text-break">{{
                        getStodgrundName(stodgrund)
                      }}</span>
                    </div>
                    @if (sfsStodgrund) {
                      <div class="d-flex justify-content-end">
                        <lib-dot-indicator
                          [isVisible]="hasSfsStodgrundChanged(worksiteId)"
                          ariaLabel="{{
                            t('question_budget_stodgrund_changes')
                          }}"
                          [tooltip]="
                            getChangeMarkTooltipHtml(worksiteId, 'sfsStodgrund')
                          "
                          [ariaDescription]="
                            getChangeMarkTooltipDescription(
                              worksiteId,
                              'sfsStodgrund'
                            )
                          "
                        ></lib-dot-indicator>
                        <span class="d-flex justify-content-end text-break">{{
                          getSfsStodgrundName(stodgrund, sfsStodgrund)
                        }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
      </ng-template>

      <ng-template
        #projektpartTablesTemplate
        let-worksite="worksite"
        let-coordinator="coordinator"
        let-inactive="inactive"
        let-removed="removed"
        let-newprojektpart="newprojektpart"
      >
        @if (
          {
            kostnaderFormControl: kostnaderFormControl.get(worksite?.id),
            finansieringFormControl: finansieringFormControl.get(worksite?.id),
          };
          as worksiteData
        ) {
          <div class="projektpart-container">
            <button
              class="projektpart-header interactive"
              [ngClass]="{
                'worksite-header': isOpen.get(worksite.id),
                readonly: data.readOnly,
              }"
              (click)="toggleSection(worksite.id)"
              [class.is-open]="isOpen.get(worksite?.id)"
              [attr.aria-label]="worksite.name"
              [attr.aria-expanded]="isOpen.get(worksite.id)"
              [attr.aria-controls]="'projektpart-' + worksite.id"
              [attr.aria-invalid]="
                data.readOnly !== ReadonlyState.Reader &&
                !(isSharedView() && data.readOnly === ReadonlyState.Locked) &&
                (worksiteData.kostnaderFormControl?.invalid ||
                  worksiteData.finansieringFormControl?.invalid)
              "
            >
              <div class="d-flex justify-content-between align-items-center">
                <div class="header-text text-start">
                  @if ((removed || newprojektpart) && showChanges()) {
                    <span class="heading-size-5 changed"
                      ><span aria-hidden="true">&#x2022; </span>
                      @if (removed) {
                        <span>{{
                          t('question_budget_inactive_participant')
                        }}</span>
                      } @else if (newprojektpart) {
                        <span>{{ t('question_budget_new_participant') }}</span>
                      }
                    </span>
                  }
                  <span class="heading-size-5" [class.inactive]="inactive">{{
                    worksite.company.name
                  }}</span>
                </div>
                @if (isOpen.get(worksite.id)) {
                  <lib-icon
                    name="minus"
                    class="collapse-icon align-self-start align-self-lg-center"
                    size="medium"
                    aria-hidden="true"
                  ></lib-icon>
                } @else {
                  <lib-icon
                    name="plus"
                    class="collapse-icon align-self-start align-self-lg-center"
                    size="medium"
                    aria-hidden="true"
                  ></lib-icon>
                }
              </div>
            </button>
            <div
              class="projektpart-header"
              [ngClass]="data.readOnly ? 'readonly' : ''"
              [class.is-open]="isOpen.get(worksite?.id)"
              [attr.aria-invalid]="
                data.readOnly !== ReadonlyState.Reader &&
                !(isSharedView() && data.readOnly === ReadonlyState.Locked) &&
                (worksiteData.kostnaderFormControl?.invalid ||
                  worksiteData.finansieringFormControl?.invalid)
              "
            >
              <div class="d-flex justify-content-between align-items-center">
                <div class="header-text text-start">
                  <div
                    class="header-contact-info d-flex mt-3 mt-lg-0 justify-content-between"
                  >
                    <span>{{
                      worksite.company.nationalRegistrationNumber ??
                        worksite.company.vat
                    }}</span>
                    <div class="divider d-none d-lg-block"></div>
                    <div class="break d-block d-lg-none"></div>
                    <span>{{ worksite.name }}</span>
                    <div class="divider d-none d-lg-block"></div>
                    <div class="break d-block d-lg-none"></div>
                    <div>
                      @if (
                        worksite.address && worksite.zipcode && worksite.city
                      ) {
                        <span
                          >{{ worksite.address }},
                          {{ worksite.zipcode | zipCode }}
                          {{ worksite.city }},</span
                        >
                      }
                      @if (worksite.country) {
                        <span>
                          {{
                            worksite.country
                              | translatedCountry: data.activeLang
                          }}</span
                        >
                      }
                    </div>
                    @if (worksite.phone) {
                      <div class="divider d-none d-lg-block"></div>
                    }

                    <div class="break d-block d-lg-none"></div>
                    <span>{{ worksite.phone }}</span>
                  </div>
                  @if (
                    data.readOnly !== ReadonlyState.Reader &&
                    !(
                      isSharedView() && data.readOnly === ReadonlyState.Locked
                    ) &&
                    (worksiteData.kostnaderFormControl?.invalid ||
                      worksiteData.finansieringFormControl?.invalid) &&
                    !hasBidragsMottagareIsFinansiarError(worksite.id)
                  ) {
                    <p class="subtitle mb-0 mt-2 error">
                      <lib-icon
                        name="alert-circle"
                        class="status-icon error"
                        size="small"
                        aria-hidden="true"
                      ></lib-icon>
                      <span>{{
                        t('question_budget_validation_participant_missing')
                      }}</span>
                    </p>
                  }
                </div>
              </div>
            </div>
            <div
              [libCollapse]="!isOpen.get(worksite.id)"
              [attr.id]="'projektpart-' + worksite.id"
              (visible)="isVisible.set(worksite.id, $event)"
            >
              <div
                class="projektpart-body"
                [ngClass]="data.readOnly ? 'readonly' : ''"
              >
                @if (isVisible.get(worksite.id)) {
                  <div class="projektpart-table">
                    <lib-interactive-table
                      [id]="question().id + '_' + worksite.id + 'k'"
                      [title]="
                        worksite.company.name +
                        ' ' +
                        t('question_budget_kostnader_table_header')
                      "
                      [rows]="budgetStandard() ? ROWSSTANDARD : KOSTNADSSLAG"
                      [columns]="yearColumns"
                      [sumRow]="true"
                      [sumCol]="!budgetStandard()"
                      [formControl]="worksiteData.kostnaderFormControl"
                      [maxColsDesktop]="7"
                      [tableContentToRight]="true"
                      [inputType]="InputType.Amount"
                      [expansionTitle]="worksite.company.name"
                      [expansionSubTitle]="
                        coordinator
                          ? t('question_budget_coordinator')
                          : undefined
                      "
                      [tableValidation]="
                        coordinator ? undefined : ['BudgetKostnaderRequired']
                      "
                      [tableRowValidation]="
                        kostnaderRowValidation.get(worksite.id)
                      "
                      [disableResize]="true"
                      (saveExpanded)="updateBudgetTables($event, worksite.id)"
                      size="medium"
                      [totalHeading]="
                        t('question_budget_total_kostnader_header')
                      "
                      suffix="SEK"
                      [tableHeading]="
                        t('question_budget_kostnader_table_header')
                      "
                      [readOnly$]="inactive ? undefined : readOnly$"
                      [readonly]="inactive ? true : undefined"
                      [defaultValue]="0"
                      [checkValidation$]="checkValidation$"
                      [updateValidation$]="updateValidation$"
                      [class.projektpart-invalid]="
                        worksiteData.kostnaderFormControl?.invalid
                      "
                      [hideValidation]="
                        data.readOnly === ReadonlyState.Reader ||
                        (isSharedView() &&
                          data.readOnly === ReadonlyState.Locked)
                      "
                      [browseLarge]="browseLarge()"
                      [browseMedium]="browseMedium()"
                      [browseSmall]="browseSmall()"
                      [changes]="
                        showChanges()
                          ? kostnaderChanges.get(worksite.id)
                          : undefined
                      "
                    ></lib-interactive-table>
                  </div>
                  <div>
                    <lib-interactive-table
                      [id]="question().id + '_' + worksite.id + 'f'"
                      [title]="
                        worksite.company.name +
                        ' ' +
                        t('question_budget_finansiering_table_header')
                      "
                      [rows]="finansieringRows.get(worksite.id)"
                      [columns]="yearColumns"
                      [sumRow]="true"
                      [sumCol]="true"
                      [formControl]="worksiteData.finansieringFormControl"
                      [maxColsDesktop]="7"
                      [tableContentToRight]="true"
                      [inputType]="InputType.Amount"
                      [expansionTitle]="worksite.company.name"
                      [expansionSubTitle]="
                        coordinator
                          ? t('question_budget_coordinator')
                          : undefined
                      "
                      [tableRowValidation]="
                        finansieringRowValidation.get(worksite.id)
                      "
                      [disableResize]="true"
                      [readonlyData]="egenFinansiering.get(worksite.id)"
                      (saveExpanded)="updateBudgetTables($event, worksite.id)"
                      size="medium"
                      [totalHeading]="
                        t('question_budget_total_finansiering_header')
                      "
                      suffix="SEK"
                      [tableHeading]="
                        t('question_budget_finansiering_table_header')
                      "
                      [readOnly$]="inactive ? undefined : readOnly$"
                      [readonly]="inactive ? true : undefined"
                      [defaultValue]="0"
                      [checkValidation$]="checkValidation$"
                      [updateValidation$]="updateValidation$"
                      [class.projektpart-invalid]="
                        worksiteData.finansieringFormControl?.invalid
                      "
                      [hideValidation]="
                        data.readOnly === ReadonlyState.Reader ||
                        (isSharedView() &&
                          data.readOnly === ReadonlyState.Locked)
                      "
                      [browseLarge]="browseLarge()"
                      [browseMedium]="browseMedium()"
                      [browseSmall]="browseSmall()"
                      [changes]="
                        showChanges()
                          ? finansieringChanges.get(worksite.id)
                          : undefined
                      "
                    ></lib-interactive-table>
                  </div>
                  <ng-container
                    *ngTemplateOutlet="
                      beraknadStodnivaTemplate;
                      context: {
                        percentage: beraknadStodniva.get(worksite.id),
                        total: false,
                        worksiteId: worksite.id,
                        maxStodniva: maxStodniva.get(worksite.id),
                        stodgrund: stodgrund.get(worksite.id),
                        sfsStodgrund: sfsStodgrund.get(worksite.id),
                        bidragsMottagare: bidragsMottagare.has(worksite.id),
                      }
                    "
                  ></ng-container>
                  <div class="below-budget">
                    @if (
                      !isChangeRequest() &&
                      !isSharedView() &&
                      isKonsultkostnadOverskriden.get(worksite.id)()
                    ) {
                      @let konsultkostnadOverskridenForklarkingFc =
                        konsultkostnadOverskridenForklaringControl.get(
                          worksite.id
                        );
                      @let val =
                        konsultkostnadOverskridenForklarkingFc.value$ | async;
                      <lib-input-container
                        [label]="
                          t('question_budget_konsultkostnad_exceeded_text')
                        "
                        [maxLength]="1000"
                        questionMarkText=""
                        [required]="false"
                        [currentLength]="
                          konsultkostnadOverskridenForklarkingFc.value.length
                        "
                      >
                        <div class="mb-2">
                          <span>{{
                            t(
                              'question_budget_konsultkostnad_exceeded_text_below'
                            )
                          }}</span>
                        </div>
                        @if (!data.readOnly) {
                          <textarea
                            vinnova-textarea
                            id="konsultkostnadOverskriden_{{ worksite.id }}"
                            [required]="false"
                            [formControl]="
                              konsultkostnadOverskridenForklarkingFc
                            "
                            size="small"
                            [error]="
                              konsultkostnadOverskridenForklarkingFc.dirty &&
                              konsultkostnadOverskridenForklarkingFc.invalid
                            "
                          ></textarea>
                        }
                        @if (data.readOnly) {
                          <div
                            [ngClass]="
                              konsultkostnadOverskridenForklarkingFc.errors ||
                              konsultkostnadOverskridenForklarkingFc.invalid
                                ? 'invalid'
                                : ''
                            "
                          >
                            <div
                              class="textarea-readonly"
                              [ngClass]="
                                val?.length < 700
                                  ? val?.length < 300
                                    ? 'small-height'
                                    : 'medium-height'
                                  : ''
                              "
                            >
                              {{ val }}
                            </div>
                          </div>
                        }
                      </lib-input-container>
                    }
                    @if (
                      !isChangeRequest() &&
                      !isSharedView() &&
                      hasSoektBidrag(worksite.id)
                    ) {
                      @let sokerBidragForIckeEkonomiskVerksamhetFc =
                        sokerBidragIckeEkonomiskVerksamhetControl.get(
                          worksite.id
                        );
                      @let val =
                        sokerBidragForIckeEkonomiskVerksamhetFc.value$ | async;
                      <div>
                        <lib-input-container
                          [label]="
                            t(
                              'question_budget_soeker_bidrag_icke_ekonomisk_question'
                            )
                          "
                          for="sokerBidragForIckeEkonomiskVerksamhet_{{
                            worksite.id
                          }}"
                          [required]="true"
                          [fileOrEndDateDescription]="
                            t('question_budget_universitet')
                          "
                          [errorText]="
                            sokerBidragForIckeEkonomiskVerksamhetFc.dirty &&
                            sokerBidragForIckeEkonomiskVerksamhetFc.errors
                              ?.required
                              ? t('radiobuttons_required')
                              : undefined
                          "
                        >
                          <div class="soker-bidrag">
                            <lib-vinnova-radiobuttons
                              [required]="true"
                              [formControl]="
                                sokerBidragForIckeEkonomiskVerksamhetFc
                              "
                              [error]="
                                sokerBidragForIckeEkonomiskVerksamhetFc.dirty &&
                                sokerBidragForIckeEkonomiskVerksamhetFc.errors
                                  ?.required
                              "
                              name="sokerBidragForIckeEkonomiskVerksamhet_{{
                                worksite.id
                              }}"
                              [radiobuttonObjects]="[
                                {
                                  id: 'SokerBidragForIckeEkonomiskVerksamhet',
                                  label: t(
                                    'question_budget_soeker_bidrag_icke_ekonomisk'
                                  ),
                                  descriptionInnerHTML: t(
                                    'question_budget_soeker_bidrag_icke_ekonomisk_text'
                                  ),
                                  disabled: data.readOnly,
                                },
                                {
                                  id: 'BedriverEkonomiskVerksamhet',
                                  label: t(
                                    'question_budget_soeker_bidrag_ekonomisk'
                                  ),
                                  disabled: data.readOnly,
                                },
                              ]"
                            >
                            </lib-vinnova-radiobuttons>
                          </div>
                        </lib-input-container>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </ng-template>
    }
  }
</ng-container>
